// extracted by mini-css-extract-plugin
export default {"grayContainer":"styles_grayContainer__um+aC"};